// extracted by mini-css-extract-plugin
export default {"exampleBox":"Commissions_exampleBox__vkoPZ"};